import type { Frontmatter } from "../client/docs-types/latest";

export const EMPTY_FRONTMATTER: Frontmatter = {
    title: undefined,
    headline: undefined,
    description: undefined,
    subtitle: undefined,
    layout: undefined,
    slug: undefined,
    image: undefined,
    "edit-this-page-url": undefined,
    "hide-toc": undefined,
    "force-toc": undefined,
    "max-toc-depth": undefined,
    "hide-nav-links": undefined,
    "hide-feedback": undefined,
    "hide-page-actions": undefined,
    "no-image-zoom": undefined,
    breadcrumb: undefined,
    excerpt: undefined,
    "canonical-url": undefined,
    "og:site_name": undefined,
    "og:title": undefined,
    "og:description": undefined,
    "og:url": undefined,
    "og:image": undefined,
    "og:image:width": undefined,
    "og:image:height": undefined,
    "og:locale": undefined,
    "og:logo": undefined,
    "twitter:title": undefined,
    "twitter:description": undefined,
    "twitter:handle": undefined,
    "twitter:image": undefined,
    "twitter:site": undefined,
    "twitter:url": undefined,
    "twitter:card": undefined,
    noindex: undefined,
    nofollow: undefined,
    "jsonld:breadcrumb": undefined,
    keywords: undefined,
    logo: undefined,
    tags: undefined,
    "last-updated": undefined
};
